import { List } from 'immutable';

const initialState = {
  listing: List(),
  getJournalsPending: true,
  getJournalsError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/mood-journal/redux/initialState.js